import { Product } from '../types';

export type Currency = 'KRW' | 'USD';

export const currencyForLang = (lang: string): Currency => {
  if (lang.startsWith('en')) return 'USD';
  return 'USD'; // US market — always USD
};

export const formatPrice = (amount: number | null | undefined, currency: Currency): string => {
  if (amount == null) return '-';
  switch (currency) {
    case 'USD':
      return `$${amount.toFixed(2)}`;
    case 'KRW':
    default:
      return `${Math.round(amount).toLocaleString()}원`;
  }
};

export const productEffective = (product: Product, _currency: Currency): number => {
  return product.price;
};

export const productOriginal = (product: Product, _currency: Currency): number => {
  return product.originalPrice;
};

export const productSale = (product: Product, _currency: Currency): number | null => {
  if (product.discountPercent && product.discountPercent > 0) {
    return product.price;
  }
  return null;
};
